import { Pipe, PipeTransform } from '@angular/core';
import { UserDetailsService } from '../../services/user-details.service';

const defaultCurrencyValue = '$ 0.00';
@Pipe({
  name: 'SlotsPipe'
})

export class SlotsPipe implements PipeTransform {
  transform(items: Array<any>, key, value): Array<any> {
    return items.filter(item => {
      return (item[key] === value)
    });
  }
}

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    value.forEach((value: string, key: string) => {
      keys.push({key: key, value: value});
    });
    return keys;
  }
}

@Pipe({name: 'displayName'})
export class KeysDisplayPipe implements PipeTransform {
  transform(value, args:string[],key) : any {
    return value.get(key);
  }
}

@Pipe({name: 'objectkeys'})
export class ObjectPipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
   if(value && value.length){
    Object.keys(value).map( key => {
      keys.push({key: key, value: value[key]});
    });
   }
    return keys;
  }
}

@Pipe({name: 'getValues'})
export class GetValuesPipe implements PipeTransform {
    transform(map: Map<any, any>): any[] {
        let ret = [];

        map.forEach((val, key) => {
            ret.push({
                key: key,
                val: val
            });
        });

        return ret;
    }
}


@Pipe({name:'currencyPipe',
pure:false})
export class CurrencyPipe implements PipeTransform{
constructor(private userDeatailsService:UserDetailsService){

}
  transform(amount, isDecimalDisabled=false) {
      let userCurrencyInfo = this.userDeatailsService.getUserCurrencyInfo();
      amount = amount && parseFloat(amount) ? parseFloat(amount) : 0 ;
      if(!isDecimalDisabled){
        amount = amount.toFixed(2);
      }
     
      if(userCurrencyInfo?.position){
        let currencySymbol = userCurrencyInfo?.symbol
        if(userCurrencyInfo?.position == 'after')
          return amount+" "+currencySymbol;
        return currencySymbol+' '+amount;
      }else
        return ""
    }
}
